import React from "react";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import "@/App.css";

export default function App() {
  return (
    <div className="App">
      <Landing />
      <Toaster richColors position="top-center" />
    </div>
  );
}
